module.exports = __webpack_public_path__ + "static/media/ic-multi-segmental-flexion.816633a3.png";